/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */


import { RemediationFlow } from './RemediationFlow';
import {
  SelectEnrollProfile,
  EnrollPoll,
  SelectEnrollmentChannel,
  EnrollmentChannelData,
  EnrollProfile,
  SelectAuthenticatorEnroll,
  SelectAuthenticatorAuthenticate,
  EnrollAuthenticator,
  AuthenticatorEnrollmentData,
  AuthenticatorVerificationData,
  ChallengeAuthenticator,
  ChallengePoll,
  Skip,
} from '../remediators';

export const RegistrationFlow: RemediationFlow = {
  'select-enroll-profile': SelectEnrollProfile,
  'enroll-profile': EnrollProfile,
  'authenticator-enrollment-data': AuthenticatorEnrollmentData,
  'select-authenticator-enroll': SelectAuthenticatorEnroll,
  'select-authenticator-authenticate': SelectAuthenticatorAuthenticate,
  'enroll-poll': EnrollPoll,
  'select-enrollment-channel': SelectEnrollmentChannel,
  'enrollment-channel-data': EnrollmentChannelData,
  'enroll-authenticator': EnrollAuthenticator,
  'authenticator-verification-data': AuthenticatorVerificationData,
  'challenge-authenticator': ChallengeAuthenticator,
  'challenge-poll': ChallengePoll,
  'skip': Skip,
};
